export const getGridSetting = (name, setting) => {
  const grids = JSON.parse(localStorage.getItem('grids'));
  if (!grids || !grids[name]) {
    return undefined;
  }
  if (!setting) {
    return grids[name];
  }
  return grids[name][setting];
}

export const setGridSetting = (name, setting, value) => {
  const grids = JSON.parse(localStorage.getItem('grids')) || {};
  if (!grids || !grids[name]) {
    grids[name] = {}
  }
  grids[name][setting] = value;
  localStorage.setItem('grids', JSON.stringify(grids))
}

export const unsetGridSetting = (name, setting) => {
  const grids = JSON.parse(localStorage.getItem('grids'));
  if (!grids || !grids[name]) {
    return;
  }
  delete grids[name][setting];
  localStorage.setItem('grids', JSON.stringify(grids))
}

export const restore = () => {
  localStorage.removeItem('grids');
}

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
}

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (err) {
  }
}
